import{useEffect as Lr,useRef as Mr}from"react";import*as Lt from"react-dom";import{Fragment as Pt,useEffect as Ue,useMemo as Er,useRef as Nt,useState as At}from"react";import Mt from"classnames";import{jsx as Ht}from"react/jsx-runtime";var zt={baseline:"vuiFlexContainer--alignItemsBaseline",center:"vuiFlexContainer--alignItemsCenter",end:"vuiFlexContainer--alignItemsEnd",start:"vuiFlexContainer--alignItemsStart",stretch:"vuiFlexContainer--alignItemsStretch"},Gt={column:"vuiFlexContainer--directionColumn",columnReverse:"vuiFlexContainer--directionColumnReverse",row:"vuiFlexContainer--directionRow",rowReverse:"vuiFlexContainer--directionRowReverse"},Dt={center:"vuiFlexContainer--justifyContentCenter",end:"vuiFlexContainer--justifyContentEnd",start:"vuiFlexContainer--justifyContentStart",spaceAround:"vuiFlexContainer--justifyContentSpaceAround",spaceBetween:"vuiFlexContainer--justifyContentSpaceBetween",spaceEvenly:"vuiFlexContainer--justifyContentSpaceEvenly"},qt={none:"vuiFlexContainer--spacingNone",xxs:"vuiFlexContainer--spacingXxs",xs:"vuiFlexContainer--spacingXs",s:"vuiFlexContainer--spacingS",m:"vuiFlexContainer--spacingM",l:"vuiFlexContainer--spacingL",xl:"vuiFlexContainer--spacingXl",xxl:"vuiFlexContainer--spacingXxl"},k=({children:e,alignItems:t="stretch",direction:r="row",justifyContent:n="start",spacing:o="m",wrap:i,className:s,fullWidth:a,...l})=>{let p=Mt(s,"vuiFlexContainer",zt[t],Gt[r],Dt[n],qt[o],{"vuiFlexContainer--wrap":i,"vuiFlexContainer--fullWidth":a});return Ht("div",{className:p,...l,children:e})};import Ot from"classnames";import{jsx as $t}from"react/jsx-runtime";var Wt={baseline:"vuiFlexItem--alignItemsBaseline",center:"vuiFlexItem--alignItemsCenter",end:"vuiFlexItem--alignItemsEnd",start:"vuiFlexItem--alignItemsStart",stretch:"vuiFlexItem--alignItemsStretch"},I=({children:e,grow:t,shrink:r,basis:n="auto",alignItems:o="stretch",className:i,truncate:s,...a})=>{let l=t===!1,p=r===!1,B=Ot("vuiFlexItem",`vuiFlexItem--${n}`,Wt[o],{[`vuiFlexItem--flexGrow${t}`]:typeof t=="number","vuiFlexItem--flexGrowNone":l,[`vuiFlexItem--flexShrink${r}`]:typeof r=="number","vuiFlexItem--flexShrinkNone":p,"vuiFlexItem--truncate":s},i);return $t("div",{className:B,...a,children:e})};var ve=0,Te=()=>(ve===Number.MAX_SAFE_INTEGER?ve=0:ve++,ve.toString());import{jsx as f,jsxs as q}from"react/jsx-runtime";var Ze=({size:e,color:t})=>f("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.26933 329",width:e,height:e,fill:t,children:f("path",{d:"m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"})}),Ke=({size:e="16px",color:t="#ffffff"})=>q("svg",{fill:t,version:"1.1",id:"Capa_1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",width:e,height:e,viewBox:"0 0 29.75 29.75",xmlSpace:"preserve",children:[f("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),f("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),q("g",{id:"SVGRepo_iconCarrier",children:[" ",q("g",{children:[" ",q("g",{children:[" ",f("path",{d:"M26.573,4.026H5.163c-1.884,0-3.413,1.707-3.413,3.321v12.976c0,0.001,0,0.002,0,0.003l-0.004-0.003L0,25.724l4.913-2.717 c0.084,0.004,0.164,0.02,0.25,0.02h21.41c1.884,0,3.177-1.09,3.177-2.703V7.347C29.75,5.733,28.457,4.026,26.573,4.026z M27.75,20.323c0,0.538-0.548,0.703-1.177,0.703H5.163c-0.629,0-1.413-0.165-1.413-0.703V7.347c0-0.539,0.784-1.321,1.413-1.321 h21.41c0.629,0,1.177,0.782,1.177,1.321V20.323z"})," ",q("g",{children:[" ",f("circle",{cx:"9.274",cy:"13.526",r:"1.874"})," ",f("circle",{cx:"15.657",cy:"13.526",r:"1.874"})," ",f("circle",{cx:"22.04",cy:"13.526",r:"1.874"})," "]})," "]})," "]})," "]})]}),Je=()=>q("svg",{fill:"#c41535",width:"16px",height:"16px",viewBox:"0 0 1024 1024",xmlns:"http://www.w3.org/2000/svg",stroke:"#c41535",strokeWidth:"20",children:[f("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),f("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),f("g",{id:"SVGRepo_iconCarrier",children:f("path",{d:"M520.741 163.801a10.234 10.234 0 00-3.406-3.406c-4.827-2.946-11.129-1.421-14.075 3.406L80.258 856.874a10.236 10.236 0 00-1.499 5.335c0 5.655 4.585 10.24 10.24 10.24h846.004c1.882 0 3.728-.519 5.335-1.499 4.827-2.946 6.352-9.248 3.406-14.075L520.742 163.802zm43.703-26.674L987.446 830.2c17.678 28.964 8.528 66.774-20.436 84.452a61.445 61.445 0 01-32.008 8.996H88.998c-33.932 0-61.44-27.508-61.44-61.44a61.445 61.445 0 018.996-32.008l423.002-693.073c17.678-28.964 55.488-38.113 84.452-20.436a61.438 61.438 0 0120.436 20.436zM512 778.24c22.622 0 40.96-18.338 40.96-40.96s-18.338-40.96-40.96-40.96-40.96 18.338-40.96 40.96 18.338 40.96 40.96 40.96zm0-440.32c-22.622 0-40.96 18.338-40.96 40.96v225.28c0 22.622 18.338 40.96 40.96 40.96s40.96-18.338 40.96-40.96V378.88c0-22.622-18.338-40.96-40.96-40.96z"})})]}),Ye=()=>q("svg",{width:"10px",height:"10px",viewBox:"-5.5 0 26 26",version:"1.1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",fill:"#2c313a",children:[f("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),f("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),q("g",{id:"SVGRepo_iconCarrier",children:[" ",f("title",{children:"chevron-right"})," ",f("desc",{children:"Created with Sketch Beta."})," ",f("defs",{children:" "})," ",q("g",{id:"Page-1",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",children:[" ",q("g",{id:"Icon-Set-Filled",transform:"translate(-474.000000, -1196.000000)",fill:"#2c313a",children:[" ",f("path",{d:"M488.404,1207.36 L477.637,1197.6 C476.806,1196.76 475.459,1196.76 474.629,1197.6 C473.798,1198.43 473.798,1199.77 474.629,1200.6 L483.885,1209 L474.629,1217.4 C473.798,1218.23 473.798,1219.57 474.629,1220.4 C475.459,1221.24 476.806,1221.24 477.637,1220.4 L488.404,1210.64 C488.854,1210.19 489.052,1209.59 489.015,1209 C489.052,1208.41 488.854,1207.81 488.404,1207.36",id:"chevron-right",children:" "})," "]})," "]})," "]})]}),et=()=>q("svg",{width:"10px",height:"10px",viewBox:"0 -4.5 24 24",version:"1.1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",fill:"#2c313a",children:[f("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),f("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),q("g",{id:"SVGRepo_iconCarrier",children:[" ",f("title",{children:"chevron-down"})," ",f("desc",{children:"Created with Sketch Beta."})," ",f("defs",{children:" "})," ",q("g",{id:"Page-1",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",children:[" ",q("g",{id:"Icon-Set-Filled",transform:"translate(-574.000000, -1201.000000)",fill:"#2c313a",children:[" ",f("path",{d:"M597.405,1201.63 C596.576,1200.8 595.23,1200.8 594.401,1201.63 L586.016,1210.88 L577.63,1201.63 C576.801,1200.8 575.455,1200.8 574.626,1201.63 C573.797,1202.46 573.797,1203.81 574.626,1204.64 L584.381,1215.4 C584.83,1215.85 585.429,1216.05 586.016,1216.01 C586.603,1216.05 587.201,1215.85 587.65,1215.4 L597.405,1204.64 C598.234,1203.81 598.234,1202.46 597.405,1201.63",id:"chevron-down",children:" "})," "]})," "]})," "]})]});import{Fragment as Ut,jsx as ae,jsxs as tt}from"react/jsx-runtime";var Re=({header:e,children:t,isOpen:r,setIsOpen:n,...o})=>{let i=Te(),s=Te();return tt(Ut,{children:[ae("button",{className:"vuiAccordionHeader",onClick:()=>n(!r),id:i,"aria-controls":s,"aria-expanded":r,...o,children:tt(k,{alignItems:"center",justifyContent:"start",spacing:"xxs",children:[ae(I,{grow:!1,shrink:!1,children:r?ae(et,{}):ae(Ye,{})}),ae(I,{className:"vuiAccordionHeader__title",grow:1,children:e})]})}),r&&ae("div",{id:s,"aria-labelledby":i,children:t})]})};import jt from"classnames";var ce=e=>e?{rel:"noopener",referrerpolicy:"no-referrer-when-downgrade"}:{rel:"noopener"};import{createContext as Qt,useContext as Xt}from"react";import{jsx as rt}from"react/jsx-runtime";var nt=Qt(void 0),Fe=({children:e,linkProvider:t,pathProvider:r,drawerTitle:n="h2"})=>{let o=a=>{if(t)return t(a);let{className:l,href:p,onClick:B,children:T,...z}=a;return rt("a",{className:l,href:p,onClick:B,...z,children:T})},i=()=>r?r():window.location.pathname,s=n;return rt(nt.Provider,{value:{createLink:o,getPath:i,DrawerTitle:s},children:e})},le=()=>{let e=Xt(nt);if(e===void 0)throw new Error("useVuiContext must be used within a VuiContextProvider");return e};import{jsx as ot}from"react/jsx-runtime";var ye=({children:e,className:t,color:r,onClick:n,href:o,target:i,track:s,...a})=>{let{createLink:l}=le(),p=jt(t,"vuiBadge",`vuiBadge--${r}`,{"vuiBadge--clickable":n!=null?n:o});return n?ot("button",{className:p,onClick:n,...a,children:e}):o?l({className:p,href:o,onClick:n,children:e,target:i,...ce(s)}):ot("div",{className:p,...a,children:e})};import{forwardRef as tr}from"react";import rr from"classnames";import{forwardRef as Zt}from"react";import it from"classnames";import{jsx as st,jsxs as _e}from"react/jsx-runtime";var Kt={left:"vuiBaseButton--alignLeft",center:"vuiBaseButton--alignCenter",right:"vuiBaseButton--alignRight"},Ce=Zt(({children:e,icon:t,iconSide:r="left",align:n="center",className:o,size:i,fullWidth:s,onClick:a,tabIndex:l,isInert:p,isDisabled:B,href:T,target:z,track:H,htmlFor:d,isSubmit:N,...E},S)=>{let O=it("vuiBaseButton",o,`vuiBaseButton--${i}`,Kt[n],{"vuiBaseButton-isInert":p,"vuiBaseButton-isDisabled":B,"vuiBaseButton--fullWidth":s,[`vuiBaseButton--${r}`]:!!t&&!!e}),h=t?st("span",{className:"vuiBaseButtonIconContainer",children:t}):null;if(d)return _e("label",{htmlFor:d,className:O,tabIndex:l,...E,children:[h,e]});if(T){let v=it("vuiBaseButtonLinkWrapper",{"vuiBaseButtonLinkWrapper--fullWidth":s});return st("a",{className:v,href:T,onClick:a,target:z,tabIndex:l,...E,...ce(H),children:_e("button",{className:O,tabIndex:-1,ref:S,children:[h,e]})})}let W={onClick:a,tabIndex:l,type:N?"submit":"button",...E};return _e("button",{className:O,...W,ref:S,children:[h,e]})});import{cloneElement as Jt}from"react";var Yt={xs:"xs",s:"xs",m:"s",l:"m"},er={accent:"accent",primary:"primary",success:"success",danger:"danger",warning:"warning",neutral:"neutral",subdued:"subdued"},Se=(e,t,r,n=er)=>e?Jt(e,{size:t?Yt[t]:"s",color:e.props.color==="inherit"?n[r]:e.props.color}):null;import{jsx as or}from"react/jsx-runtime";var nr={accent:"empty",primary:"empty",success:"empty",danger:"empty",warning:"empty",neutral:"neutral",subdued:"subdued"},Pe=tr(({children:e,icon:t,color:r,size:n="m",className:o,isSelected:i,isDisabled:s,...a},l)=>{let p=rr(o,"vuiButtonPrimary",`vuiButtonPrimary--${r}`,{"vuiButtonPrimary-isSelected":i}),B=Se(t,n,r,nr);return or(Ce,{ref:l,className:p,icon:B,size:n,isDisabled:s,...a,children:e})});import{forwardRef as ir}from"react";import sr from"classnames";import{jsx as cr}from"react/jsx-runtime";var ar={accent:"accent",primary:"primary",success:"success",danger:"danger",warning:"warning",neutral:"neutral",subdued:"subdued"},Ne=ir(({children:e,icon:t,color:r,size:n="m",className:o,isSelected:i,isDisabled:s,solid:a,...l},p)=>{let B=sr(o,"vuiButtonSecondary",`vuiButtonSecondary--${r}`,{"vuiButtonSecondary-isSelected":i,"vuiButtonSecondary--solid":a}),T=Se(t,n,r,ar);return cr(Ce,{ref:p,className:B,icon:T,size:n,isDisabled:s,...l,children:e})});import at from"classnames";import{jsx as ct}from"react/jsx-runtime";var Ae=({children:e,columns:t=2,spacing:r="m",className:n,...o})=>{let i=at("vuiGridContainer",n),s=at("vuiGrid",`vuiGrid--${r}`,`vuiGrid--columns${t}`);return ct("div",{className:i,...o,children:ct("div",{className:s,children:e})})};import Ee from"classnames";import{jsx as lt}from"react/jsx-runtime";var Ve=({children:e,href:t,target:r,onClick:n,className:o,track:i,isAnchor:s,...a})=>{let{createLink:l}=le();if(!t)return lt("button",{className:Ee("vuiLink","vuiLink--button",o),onClick:n,...a,children:e});let p={...a,...ce(i)};return r==="_blank"&&(p.target=r),s?lt("a",{className:Ee("vuiLink",o),href:t,onClick:n,...p,children:e}):l({className:Ee("vuiLink",o),href:t,onClick:n,children:e,...p})};import lr from"classnames";import{jsx as Le}from"react/jsx-runtime";var Me=({className:e,size:t="m",value:r,onChange:n,placeholder:o,autoFocus:i,onSubmit:s,...a})=>{let l=lr("vuiSearchInput",`vuiSearchInput--${t}`,e);return Le("form",{onSubmit:s,children:Le("div",{className:l,children:Le("input",{className:"vuiSearchInput__input",type:"text",autoComplete:"off",autoCapitalize:"off",spellCheck:"false",autoFocus:i,placeholder:o,value:r,onChange:n,...a})})})};import ur from"classnames";import{jsx as pr}from"react/jsx-runtime";var b=({size:e="m"})=>{let t=ur("vuiSpacer",{[`vuiSpacer--${e}`]:e});return pr("div",{className:t})};import dr from"classnames";import{jsx as we}from"react/jsx-runtime";var mr={xs:"vuiSpinner--xs",s:"vuiSpinner--s",m:"vuiSpinner--m",l:"vuiSpinner--l",xl:"vuiSpinner--xl",xxl:"vuiSpinner--xxl",xxxl:"vuiSpinner--xxxl"},pe=({color:e="accent",size:t="m"})=>{let r=dr("vuiSpinner",mr[t],`vuiSpinner--${e}`);return we("span",{className:r,children:we("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 50 50",children:we("path",{fill:"#000",d:"M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z",children:we("animateTransform",{attributeType:"xml",attributeName:"transform",type:"rotate",from:"0 25 25",to:"360 25 25",dur:"0.6s",repeatCount:"indefinite"})})})})};import gr from"classnames";import{jsx as xr}from"react/jsx-runtime";var Z=({children:e,className:t,id:r,truncate:n,size:o="s",align:i,...s})=>{let a=gr("vuiText",`vuiText--${o}`,{[`vuiText--${i}`]:i,"vuiText--truncate":n},t);return xr("div",{className:a,id:r,...s,children:e})};import fr from"classnames";import{jsx as hr}from"react/jsx-runtime";var te=({children:e,color:t,className:r})=>{let n=fr(r,"vuiTextColor",`vuiTextColor--${t}`);return hr("span",{className:n,children:e})};import br from"classnames";import{cloneElement as vr}from"react";var de=({children:e,className:t,size:r,align:n,...o})=>vr(e,{className:br("vuiTitle",`vuiTitle--${r}`,{[`vuiTitle--${n}`]:n},t,e.props.className),...o});import yr from"classnames";import{Fragment as ut,jsx as me,jsxs as pt}from"react/jsx-runtime";var ge=({children:e,className:t,href:r,onClick:n,title:o,fullWidth:i,...s})=>{let{createLink:a}=le(),l=yr("vuiTopicButton",t,{"vuiTopicButton--fullWidth":i}),p=pt(ut,{children:[o&&pt(ut,{children:[me(de,{size:"s",children:me("p",{children:me(te,{color:"primary",children:o})})}),e&&me(b,{size:"xxs"})]}),e]});return r?a({className:l,href:r,onClick:n,children:p,...s}):me("button",{className:l,onClick:n,...s,children:p})};import{jsx as ke,jsxs as Cr}from"react/jsx-runtime";var dt=({query:e,setQuery:t,onSubmit:r,placeholder:n,buttonLabel:o,isButtonDisabled:i,size:s})=>Cr(k,{alignItems:"center",spacing:"xs",children:[ke(I,{grow:1,children:ke(Me,{size:s,value:e,onChange:p=>{t(p.target.value)},onSubmit:p=>{p.preventDefault(),r()},placeholder:n,autoFocus:!0,"data-testid":"queryInput"})}),ke(I,{children:ke(Pe,{color:"primary",size:s,onClick:()=>r(),isDisabled:i,children:o})})]});import kr from"markdown-to-jsx";var ze=(e,t)=>{let r=[],n=t.match(/\[\d+\]/g)||[],o=new Set;for(let i=0;i<n.length;i++){let s=n[i],a=Number(s.slice(1,s.length-1))-1;o.has(a)||(r.push(e[a]),o.add(a))}return r};var Ge=e=>{let t=/\[(\d+(,*\s*\d*)*)\]/g,r=[],n,o=0;for(;(n=t.exec(e))!==null;){let s=n.index,a=n[1],l=e.slice(o,s).trim();r.push({text:l,references:a.replace(/\s/g,"").split(",")}),o=s+n[0].length}let i=e.slice(o).trim();return i.length>0&&r.push({text:i}),r};var De=e=>{let t=e.match(/\[\d+\]/g)||[],r=[...new Set(t)],n={};return r.forEach((o,i)=>{n[o]=`[${i+1}]`}),e.replace(/\[\d+\]/g,o=>n[o])};var mt="%START_SNIPPET%",gt="%END_SNIPPET%",xe=e=>{let[t,r]=e.indexOf(mt)!==-1?e.split(mt):["",e],[n,o]=r.indexOf(gt)!==-1?r.split(gt):[r,""];return{pre:t,post:o,text:n}};import{Fragment as wr,jsx as J,jsxs as qe}from"react/jsx-runtime";var xt=({searchResults:e,isOpen:t=!1,setIsOpen:r=()=>{}})=>qe(Re,{header:`Based on ${e.length} ${e.length===1?"fact":"facts"}`,isOpen:t,setIsOpen:r,children:[J(b,{size:"s"}),e.map((n,o)=>qe("div",{children:[J(Sr,{result:n,position:o}),o<e.length-1&&J(b,{size:"s"})]},o))]}),Sr=({result:e,position:t})=>{var o;let r=e.document_metadata.url,{text:n}=xe((o=e==null?void 0:e.snippet)==null?void 0:o.text);return J(wr,{children:qe(k,{alignItems:"start",spacing:"s",children:[J(I,{grow:!1,shrink:!1,children:J("div",{className:"vrcbChatSearchResultPosition",children:t+1})}),J(I,{grow:1,shrink:1,children:J(Z,{size:"s",children:J("p",{children:r?J("a",{href:r,target:"_blank",children:n}):n})})})]})})};import{useState as Br}from"react";import{Fragment as fe,jsx as P,jsxs as K}from"react/jsx-runtime";var Ir=e=>Ge(e).reduce((r,{text:n,references:o})=>(o?(r.push(n),n&&n[n.length-1]!==" "&&r.push(" "),o.forEach((s,a)=>{a>0&&r.push(" "),r.push(`<SummaryCitation reference={${s}} />`)})):r.push(n),r),[]).join(" "),He=({question:e,answer:t,searchResults:r,factualConsistencyScore:n,onRetry:o,isStreaming:i})=>{let[s,a]=Br(!1),l;if(o)l=K("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--error",children:[P(b,{size:"m"}),K(k,{alignItems:"center",spacing:"none",children:[K(k,{alignItems:"center",spacing:"xxs",children:[P(I,{grow:!1,shrink:!0,children:P(Je,{})}),P(I,{grow:!1,children:"Message not sent."})]}),o&&K(fe,{children:[P(b,{size:"s"}),P(k,{alignItems:"center",spacing:"none",children:P("button",{className:"vrcbRetryButton",onClick:()=>o(),children:"Try again"})})]})]})]});else if(t){let p=(r?ze(r,t):[]).slice(0,7),B=r?De(t):t,T=Ir(B);l=P("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--answer",children:K("div",{className:"vrcbChatMessage",children:[K(Z,{size:"s",children:[P(kr,{children:T,options:{forceInline:!0,overrides:{SummaryCitation:{component:({reference:H})=>K(fe,{children:[" ",P("button",{onClick:()=>a(!0),children:P("span",{className:"vrcbChatSummaryCitation",children:H})})]})}}}}),i&&K("span",{children:[" ",P(pe,{size:"xs"})]})]}),n&&K(fe,{children:[P(b,{size:"xs"}),n]}),p&&p.length>0&&K(fe,{children:[P(b,{size:"s"}),P(xt,{searchResults:p,isOpen:s,setIsOpen:a})]})]})})}return K(fe,{children:[e&&P("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--question",children:P("div",{className:"vrcbChatMessage",children:e})}),P(b,{size:"xs"}),l]})};import{useEffect as vt,useRef as Fr,useState as ie}from"react";var ft="https://api.vectara.io",Oe="%START_SNIPPET%",We="%END_SNIPPET%";import{streamQueryV2 as _r}from"@vectara/stream-query-client";var Tr=e=>{if(e){if(e.type==="none")return{type:e.type};if(e.type==="customer_reranker")return{type:e.type,reranker_id:e.rerankerId};if(e.type==="mmr")return{type:e.type,diversity_bias:e.diversityBias}}},Rr=e=>{if(e){if(e.style==="none"||e.style==="numeric")return{style:e.style};if(e.style==="html"||e.style==="markdown")return{style:e.style,url_pattern:e.urlPattern,text_pattern:e.textPattern}}},ht=async({customerId:e,corpusKeys:t,apiKey:r,query:n,domain:o,search:i,generation:s,chat:a})=>{var W;let{metadataFilter:l,lexicalInterpolation:p,customDimensions:B,semantics:T,offset:z,limit:H,contextConfiguration:d,reranker:N}=i,E={query:n,search:{corpora:t.split(",").map(v=>({corpus_key:v,metadata_filter:l,lexical_interpolation:p,custom_dimensions:B,semantics:T})),offset:z,limit:H,context_configuration:{characters_before:d==null?void 0:d.charactersBefore,characters_after:d==null?void 0:d.charactersAfter,sentences_before:d==null?void 0:d.sentencesBefore,sentences_after:d==null?void 0:d.sentencesAfter,start_tag:d==null?void 0:d.startTag,end_tag:d==null?void 0:d.endTag},reranker:Tr(N)}};if(s){let{promptName:v,maxUsedSearchResults:V,promptText:U,maxResponseCharacters:Q,responseLanguage:X,modelParameters:R,citations:L,enableFactualConsistencyScore:Y}=s;E.generation={prompt_name:v,max_used_search_results:V,prompt_text:U,max_response_characters:Q,response_language:X,model_parameters:R&&{max_tokens:R.maxTokens,temperature:R.temperature,frequency_penalty:R.frequencyPenalty,presence_penalty:R.presencePenalty},citations:Rr(L),enable_factual_consistency_score:Y}}a&&(E.chat={store:a.store});let S={"customer-id":e,"Content-Type":"application/json"};r&&(S["x-api-key"]=r);let O=`${o!=null?o:ft}/v2/chats`,h=await fetch(O,{method:"POST",headers:S,body:JSON.stringify(E)});if(h.status===400||h.status===403||h.status===404){let v=await h.json();throw new Error(`BAD REQUEST: ${(W=v==null?void 0:v.messages[0])!=null?W:v.field_errors}`)}if(h.status!==200)throw new Error(h.status.toString());return await h.json()};var yt="vectara-summary-ext-v1.2.0",Ct=272725718,St=.005,wt=({customerId:e,corpusKeys:t,apiKey:r,numberOfSearchResults:n=10,language:o="eng",enableFactualConsistencyScore:i,summaryPromptName:s=yt,customPrompt:a=void 0,rerankerId:l=Ct,lambda:p=St,enableStreaming:B=!0,agenticConfiguration:T,requestSource:z})=>{let[H,d]=ie([]),N=Fr(""),[E,S]=ie(null),[O,h]=ie(!1),[W,v]=ie(!1),[V,U]=ie(null),[Q,X]=ie(!1),[R,L]=ie(null),Y=async({query:w,isRetry:ee=!1})=>{var re,ne,_;let $,F,y;if(O)return;if(ee&&X(!1),S(null),N.current=w,h(!0),S({id:"placeholder-message-id",type:"turn",question:w,answer:"",results:[],factualConsistencyScore:void 0}),T){let g=H.reduce((c,x)=>(x.type==="turn"&&c.push(x),c),[]).reduce((c,x)=>(c.push({role:"user",message:x.question}),x.answer&&c.push({role:"chatbot",message:x.answer}),c),[]);g.push({role:"user",message:N.current});let A=await(await fetch(T.url,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({messages:g})})).json();y=T.onAgenticResponse(A),{content:$,post:F}=(re=y==null?void 0:y.message)!=null?re:{}}let D;if(B)if(v(!0),$)h(!1),await j($),F&&(await j("",!0),await j(F)),v(!1),L((ne=y==null?void 0:y.userActionOptions)!=null?ne:null);else try{let u=async C=>{var A;switch(C.type){case"requestError":case"genericError":case"error":X(!0),h(!1);break;case"chatInfo":U(C.chatId),S(c=>{var x,M;return{id:C.chatId,type:"turn",question:N.current,answer:(x=c==null?void 0:c.answer)!=null?x:"",results:(M=c==null?void 0:c.results)!=null?M:[]}});break;case"searchResults":D=C.searchResults.map(c=>{y==null||y.userActionOptions;let{pre:x,text:M,post:oe}=xe(c.text);return{...c,snippet:{pre:x,text:M,post:oe}}}),S(c=>{var x,M;return{id:(x=c==null?void 0:c.id)!=null?x:"",type:"turn",question:N.current,answer:(M=c==null?void 0:c.answer)!=null?M:"",results:D}});break;case"generationChunk":v(!0),h(!1),S(c=>{var x,M,oe;return{id:(x=c==null?void 0:c.id)!=null?x:"",type:"turn",question:N.current,answer:(M=C.updatedText)!=null?M:"",results:(oe=c==null?void 0:c.results)!=null?oe:[]}});break;case"factualConsistencyScore":S(c=>{var x,M,oe;return{id:(x=c==null?void 0:c.id)!=null?x:"",type:"turn",question:N.current,answer:(M=c==null?void 0:c.answer)!=null?M:"",results:(oe=c==null?void 0:c.results)!=null?oe:[],factualConsistencyScore:C.factualConsistencyScore}});break;case"end":F&&(await j("",!0),await j(F)),v(!1),L((A=y==null?void 0:y.userActionOptions)!=null?A:null);break}},g={apiKey:r,customerId:e,query:w,corpusKey:t,search:{offset:0,metadataFilter:"",lexicalInterpolation:p,reranker:l===272725718?{type:"mmr",diversityBias:0}:{type:"customer_reranker",rerankerId:`rnk_${l}`},contextConfiguration:{sentencesBefore:2,sentencesAfter:2,startTag:Oe,endTag:We}},chat:{store:!0,conversationId:V!=null?V:void 0},generation:{generationPresetName:s,maxUsedSearchResults:n,enableFactualConsistencyScore:i,responseLanguage:o,promptTemplate:a}};await _r({streamQueryConfig:g,onStreamEvent:u,requestSource:z})}catch(u){console.log("Summary error",u),X(!0),h(!1);return}else try{if($)d(u=>[...u,{id:`agentic-query-${Date.now()}`,type:"turn",question:N.current,answer:$+(F?`<br><br>${F}`:""),results:D!=null?D:[],factualConsistencyScore:void 0}]);else{let u=await ht({apiKey:r,customerId:e,query:w,corpusKeys:t,search:{offset:0,metadataFilter:"",lexicalInterpolation:p,reranker:l===272725718?{type:"mmr",diversityBias:0}:{type:"customer_reranker",rerankerId:`rnk_${l}`},contextConfiguration:{sentencesBefore:2,sentencesAfter:2,startTag:Oe,endTag:We}},chat:{store:!0,conversationId:V!=null?V:void 0},generation:{promptName:s,maxUsedSearchResults:n,enableFactualConsistencyScore:i,responseLanguage:o}});D=u.search_results.map(g=>{let{pre:C,text:A,post:c}=xe(g.text);return{...g,snippet:{pre:C,text:A,post:c}}}),U(u.chat_id),d(g=>{var C;return[...g,{id:u.chat_id,type:"turn",question:N.current,answer:((C=u==null?void 0:u.answer)!=null?C:"")+(F?`<br><br>${F}`:""),results:D!=null?D:[],factualConsistencyScore:u.factual_consistency_score}]})}L((_=y==null?void 0:y.userActionOptions)!=null?_:null),S(null),h(!1)}catch(u){console.log("Summary error",u),X(!0),h(!1);return}},G=()=>{d([]),U(null)},j=(w,ee)=>new Promise($=>{let F=w.split(""),y={id:"placeholder-message-id",type:"turn",question:N.current,factualConsistencyScore:void 0},D=window.setInterval(()=>{var ne;let re=(ne=F.shift())!=null?ne:"";S(_=>{var u,g;return{...y,results:(u=_==null?void 0:_.results)!=null?u:[],answer:((g=_==null?void 0:_.answer)!=null?g:"")+re}}),F.length===0&&(clearInterval(D),ee&&S(_=>{var u,g;return{...y,results:(u=_==null?void 0:_.results)!=null?u:[],answer:((g=_==null?void 0:_.answer)!=null?g:"")+"<br><br>"}}),$())},10)});return vt(()=>{!W&&E&&(d([...H,E]),S(null))},[W]),vt(()=>{R&&d(w=>[...w,{id:`user-action-${Date.now().toString()}`,type:"action",options:R}]),L(null)},[R]),{sendMessage:Y,activeMessage:E,messageHistory:H,isLoading:O,isStreamingResponse:W,startNewConversation:G,hasError:Q}};import{Fragment as Pr,jsx as Be}from"react/jsx-runtime";var kt=()=>Be(Pr,{children:Be("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--thinking",children:Be("div",{className:"vrcbChatMessage",children:Be("div",{className:"vrcbLoader"})})})});import{jsx as he,jsxs as Bt}from"react/jsx-runtime";var $e=({score:e})=>{let t;if(e===void 0)t=he(ye,{color:"accent",children:"Calculating Factual Consistency Score\u2026"});else{let r=parseFloat(e.toFixed(2)),n="neutral";r===0?n="danger":r===1&&(n="success"),t=Bt(ye,{color:n,children:["Factual Consistency Score: ",r]})}return Bt(k,{alignItems:"center","data-testid":"factualConsistencyBadge",children:[e===void 0&&he(pe,{size:"s"}),t,he(Z,{size:"xs",children:he("p",{children:he(Ve,{href:"https://docs.vectara.com/docs/api-reference/search-apis/search?#factual-consistency-score",target:"_blank",children:"What's this?"})})})]})};import{Fragment as It,jsx as be,jsxs as Tt}from"react/jsx-runtime";var Rt=({children:e,onClick:t,title:r})=>be(ge,{onClick:t,"data-testid":"exampleQuestion",children:Tt(It,{children:[r&&Tt(It,{children:[be(de,{size:"s",children:be("p",{children:be(te,{color:"primary",children:r})})}),e&&be(b,{size:"xxs"})]}),e]})});import{jsx as Ie,jsxs as Nr}from"react/jsx-runtime";var Ft=()=>Nr(k,{className:"vrcbEmptyMessages",spacing:"none",alignItems:"center",justifyContent:"center",direction:"column",children:[Ie(Ke,{size:"80px",color:"#cbcdde"}),Ie(Z,{children:Ie("p",{children:Ie(te,{color:"subdued",children:"Ask anything."})})})]});import{jsx as se,jsxs as Ar}from"react/jsx-runtime";var _t=({exampleQuestions:e,onSubmitChat:t})=>e.length>0?Ar("div",{className:"vrcbExampleQuestionsContainer",children:[se(Z,{children:se("p",{children:se(te,{color:"subdued",children:"Try out these example questions"})})}),se(b,{size:"m"}),se(Ae,{columns:3,children:e.map(n=>se(Rt,{onClick:()=>t(n),title:n},n))})]}):se(Ft,{});import{Fragment as Et,jsx as m,jsxs as ue}from"react/jsx-runtime";var Vr={large:"l",medium:"m"},Vt=({customerId:e,corpusKeys:t,apiKey:r,title:n="My Chatbot",placeholder:o="Chat with your AI Assistant",exampleQuestions:i,inputSize:s="large",emptyStateDisplay:a,isInitiallyOpen:l,zIndex:p=9999,numberOfSearchResults:B=10,language:T="eng",enableFactualConsistencyScore:z,summaryPromptName:H,customPrompt:d,rerankerId:N,lambda:E,enableStreaming:S=!0,agenticConfiguration:O,requestSource:h})=>{let[W,v]=At(l!=null?l:!1),[V,U]=At(""),{sendMessage:Q,startNewConversation:X,messageHistory:R,isLoading:L,hasError:Y,activeMessage:G,isStreamingResponse:j}=wt({customerId:e,corpusKeys:t,apiKey:r,numberOfSearchResults:B,language:T,enableFactualConsistencyScore:z,summaryPromptName:H,customPrompt:d,rerankerId:N,lambda:E,enableStreaming:S,agenticConfiguration:O,requestSource:h}),w=Nt(null),ee=Nt(!0),$=()=>{setTimeout(()=>{var u,g;ee.current&&((g=w.current)==null||g.scrollTo({left:0,top:(u=w.current)==null?void 0:u.scrollHeight,behavior:"smooth"}))},0)};Ue(()=>{l!==void 0&&v(l)},[l]),Ue(()=>{let u=w.current,g=()=>{let C=w.current?Math.abs(w.current.scrollHeight-w.current.clientHeight-w.current.scrollTop)<50:!0;ee.current=C};return u==null||u.addEventListener("scroll",g),()=>{u==null||u.removeEventListener("scroll",g)}},[]);let F=Er(()=>R.map((u,g)=>{if(u.type==="action"){let{options:C}=u;return m(Pt,{children:m("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--actionResponse",children:m(k,{spacing:"m",children:C==null?void 0:C.map((A,c)=>m(ge,{href:A.url,title:A.label,onClick:()=>{var x;A.message&&Q({query:A.message}),(x=A.onSelect)==null||x.call(A)}},`messageHistoryItem-${g}-actionOption-${c}`))})})},g)}else{let{question:C,answer:A,results:c,factualConsistencyScore:x}=u,M=Y&&g===R.length-1?()=>Q({query:C,isRetry:!0}):void 0;return ue(Pt,{children:[m(He,{question:C,answer:A,searchResults:c,factualConsistencyScore:z&&m($e,{score:x}),onRetry:M}),g<R.length-1&&m(b,{size:"m"})]},g)}}),[R]),y=L||R.length>0||G,D=L||j||V.trim().length===0,re=u=>{D&&!u||(U(""),Q({query:u!=null?u:V}))},ne=F.length===0?null:m(b,{size:G?"m":"l"});Ue($,[L,G]);let _=W?ue("div",{className:"vrcbChatbotWrapper",style:{zIndex:p},children:[ue(k,{className:"vrcbHeader",spacing:"none",direction:"row",children:[m(I,{grow:1,alignItems:"center",children:n}),m(I,{alignItems:"center",children:m("button",{onClick:()=>v(!1),children:m(Ze,{size:"12px",color:"#2c313a"})})})]}),ue(k,{direction:"column",spacing:"none",className:"vrcbChatbotInnerWrapper",children:[m(I,{className:"vrcbMessagesWrapper",basis:"fill",children:m("div",{ref:w,children:y?ue(Et,{children:[m(b,{size:"xs"}),F,ne,G&&ue(Et,{children:[m(He,{question:G.question,answer:G.answer,searchResults:G.results,factualConsistencyScore:z&&m($e,{score:G.factualConsistencyScore}),onRetry:Y?()=>Q({query:G.question,isRetry:!0}):void 0,isStreaming:j}),m(b,{size:"l"})]}),L&&m(kt,{}),m(k,{fullWidth:!0,justifyContent:"center",children:m(I,{children:m(Ne,{color:"neutral",size:"xs",onClick:X,isDisabled:L,children:"Start new conversation"})})}),m(b,{size:"l"})]}):a!=null?a:m(_t,{exampleQuestions:i!=null?i:[],onSubmitChat:re})})}),m(I,{grow:!1,shrink:!1,className:"vrcbChatInputContainer",children:m(dt,{placeholder:o,buttonLabel:"Send",query:V,setQuery:U,isButtonDisabled:D,onSubmit:re,size:Vr[s]})})]})]}):m("button",{className:"vrcbChatbotButton",onClick:()=>v(!0),style:{zIndex:p},children:n});return m(Fe,{children:_})};var Qe=`:host {
  all: initial;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.vrcbChatbotButton {
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 9999;
  background-color: #264cd6;
  color: #ffffff;
  white-space: nowrap;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  transition: all 0.2s;
  line-height: 1;
  cursor: pointer;
  font-size: 16px;
  padding: 8px 16px;
  height: 34px;
}
.vrcbChatbotButton:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.vrcbChatMessageContainer {
  display: flex;
}

.vrcbChatMessage {
  padding: 12px 16px;
  border-radius: 16px;
}

.vrcbChatMessageContainer--question {
  justify-content: flex-start;
  padding: 0 40px 0 12px;
}
.vrcbChatMessageContainer--question .vrcbChatMessage {
  color: #2c313a;
  font-weight: 600;
  font-size: 14px;
  padding-left: 0;
}

.vrcbChatMessageContainer--actionResponse {
  justify-content: flex-start;
  padding: 16px 40px 16px 12px;
}
.vrcbChatMessageContainer--actionResponse .vrcbChatMessage {
  color: #2c313a;
  font-weight: 600;
  font-size: 14px;
  padding-left: 0;
}

.vrcbChatMessageContainer--thinking,
.vrcbChatMessageContainer--answer {
  padding: 0 40px;
  padding-right: 12px;
}
.vrcbChatMessageContainer--thinking .vrcbChatMessage,
.vrcbChatMessageContainer--answer .vrcbChatMessage {
  background-color: #f3f7fb;
}

.vrcbChatMessageContainer--error,
.vrcbChatMessageContainer--answer {
  justify-content: flex-start;
}

.vrcbChatMessageContainer--error {
  padding: 0 24px;
  font-size: 12px;
}

.vrcbChatMessageContainer--thinking {
  justify-content: flex-end;
}
.vrcbChatMessageContainer--thinking .vrcbChatMessage {
  padding-left: 24px;
  padding-right: 24px;
}

.vrcbChatMessageContainer--answer .vrcbChatMessage {
  color: #000;
}

.vrcbChatMessageContainer--error .vrcbChatMessage {
  color: #c41535;
}

.vrcbChatInputContainer {
  position: relative;
}
.vrcbChatInputContainer::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  height: 20px;
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));
  pointer-events: none;
}

.vrcbChatSummaryCitation,
.vrcbChatSearchResultPosition {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000;
  padding: 2px 4px;
  font-size: 12px;
  border-radius: 4px;
  font-weight: 600;
  line-height: 1.4;
}

.vrcbChatSummaryCitation {
  display: inline;
}

.vrcbChatbotWrapper {
  align-items: stretch;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 9999;
  max-width: 600px;
  width: calc(100vw - 24px);
  max-height: 800px;
  height: calc(100vh - 24px);
}

.vrcbChatbotInnerWrapper {
  gap: 8px;
  flex-basis: 100%;
  min-height: 0;
  padding: 0 8px 8px;
}

.vrcbMessagesWrapper {
  flex-basis: 100%;
  min-height: 0;
}
.vrcbMessagesWrapper > div {
  height: 100%;
  overflow-y: auto;
}

.vrcbHeader {
  border-bottom: 1px solid #e3e4f3;
  color: #69707d;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  padding: 8px;
}
.vrcbHeader > div {
  flex-direction: row;
}

.vrcbEmptyMessages {
  height: 100%;
}

.vrcbRetryButton {
  color: #264cd6;
  font-weight: 600;
  padding: 2px 4px;
}

@media (max-width: 700px) {
  .vrcbChatbotWrapper {
    right: 0;
    bottom: 0;
    width: 100vw;
    max-width: 100vw;
    border: none;
    border-top: 1px solid #cbcdde;
  }
}
@media (max-height: 840px) {
  .vrcbChatbotWrapper {
    right: 0;
    bottom: 0;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    border: none;
    border-left: 1px solid #cbcdde;
  }
}
.vrcbLoader,
.vrcbLoader:before,
.vrcbLoader:after {
  width: 8px;
  aspect-ratio: 0.5;
  display: grid;
  background: radial-gradient(#000 68%, rgba(0, 0, 0, 0) 72%) center/100% 50% no-repeat;
  animation: load 1.2s infinite linear calc(var(--_s, 0) * 0.4s);
  transform: translate(calc(var(--_s, 0) * 150%));
}

.vrcbLoader {
  opacity: 0.4;
}

.vrcbLoader:before,
.vrcbLoader:after {
  content: "";
  grid-area: 1/1;
  opacity: 1;
}

.vrcbLoader:before {
  --_s: -1;
}

.vrcbLoader:after {
  --_s: 1;
}

@keyframes load {
  20% {
    background-position: top;
  }
  40% {
    background-position: center;
  }
  60% {
    background-position: center;
  }
}
.vrcbExampleQuestionsContainer {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body,
textarea {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: none;
  vertical-align: baseline;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

a[href],
button,
[role=button] {
  cursor: pointer;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
}

input {
  margin: 0;
  padding: 0;
}

input:disabled {
  opacity: 1; /* required on iOS */
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  margin: 0;
}

fieldset {
  min-inline-size: auto;
}

.vuiAccordionHeader {
  font-size: 14px;
  border-bottom: 1px solid #cbcdde;
  width: 100%;
  padding: 8px 0;
}
.vuiAccordionHeader:hover {
  text-decoration: underline;
  background-color: #f3f7fb;
}

.vuiAccordionHeader__title {
  text-align: left;
}

.vuiBadge {
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 12px;
  font-family: inherit;
  white-space: nowrap;
  text-decoration: none;
}

.vuiBadge--clickable {
  cursor: pointer;
}

.vuiBadge--accent {
  color: #551edf !important;
  background-color: rgba(85, 30, 223, 0.1);
  border: 1px solid rgba(85, 30, 223, 0.1);
  transition: all 0.2s;
}
.vuiBadge--accent.vuiBadge--clickable:hover {
  border-color: #551edf;
  text-decoration: none;
}

.vuiBadge--primary {
  color: #264cd6 !important;
  background-color: rgba(38, 76, 214, 0.1);
  border: 1px solid rgba(38, 76, 214, 0.1);
  transition: all 0.2s;
}
.vuiBadge--primary.vuiBadge--clickable:hover {
  border-color: #264cd6;
  text-decoration: none;
}

.vuiBadge--success {
  color: #04821f !important;
  background-color: rgba(4, 130, 31, 0.1);
  border: 1px solid rgba(4, 130, 31, 0.1);
  transition: all 0.2s;
}
.vuiBadge--success.vuiBadge--clickable:hover {
  border-color: #04821f;
  text-decoration: none;
}

.vuiBadge--warning {
  color: #965a15 !important;
  background-color: rgba(150, 90, 21, 0.1);
  border: 1px solid rgba(150, 90, 21, 0.1);
  transition: all 0.2s;
}
.vuiBadge--warning.vuiBadge--clickable:hover {
  border-color: #965a15;
  text-decoration: none;
}

.vuiBadge--danger {
  color: #c41535 !important;
  background-color: rgba(196, 21, 53, 0.1);
  border: 1px solid rgba(196, 21, 53, 0.1);
  transition: all 0.2s;
}
.vuiBadge--danger.vuiBadge--clickable:hover {
  border-color: #c41535;
  text-decoration: none;
}

.vuiBadge--neutral {
  color: #2c313a !important;
  background-color: #f3f7fb;
  border: 1px solid rgba(44, 49, 58, 0.1);
  transition: all 0.2s;
}
.vuiBadge--neutral.vuiBadge--clickable:hover {
  border-color: #2c313a;
  text-decoration: none;
}

.vuiBaseButtonIconContainer {
  line-height: 0;
}

.vuiBaseButtonLinkWrapper {
  text-decoration: none;
}
.vuiBaseButtonLinkWrapper:hover {
  text-decoration: none;
}

.vuiBaseButtonLinkWrapper--fullWidth {
  width: 100%;
}

.vuiBaseButton {
  white-space: nowrap;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  line-height: 1;
  cursor: pointer;
}

.vuiBaseButton--alignLeft {
  justify-content: flex-start;
}

.vuiBaseButton--alignCenter {
  justify-content: center;
}

.vuiBaseButton--alignRight {
  justify-content: flex-end;
}

.vuiBaseButton-isInert,
.vuiBaseButton-isDisabled {
  cursor: default;
  pointer-events: none;
}

.vuiBaseButton-isDisabled {
  opacity: 0.5;
}

.vuiBaseButton--left .vuiBaseButtonIconContainer {
  margin-right: 8px;
}

.vuiBaseButton--right {
  flex-direction: row-reverse;
}
.vuiBaseButton--right .vuiBaseButtonIconContainer {
  margin-left: 8px;
  margin-right: 0;
}

.vuiBaseButton--fullWidth {
  width: 100%;
}

.vuiBaseButton--xs {
  font-size: 14px;
  padding: 4px 8px;
  height: 24px;
}

.vuiBaseButton--s {
  font-size: 14px;
  padding: 6px 8px;
  height: 28px;
}

.vuiBaseButton--m {
  font-size: 16px;
  padding: 8px 16px;
  height: 34px;
}

.vuiBaseButton--l {
  font-size: 16px;
  padding: 12px 24px;
  height: 47px;
}

.vuiButtonPrimary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonPrimary--accent {
  color: #ffffff;
  background-color: #551edf;
  border: 1px solid #551edf;
}
.vuiButtonPrimary--accent.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--primary {
  color: #ffffff;
  background-color: #264cd6;
  border: 1px solid #264cd6;
}
.vuiButtonPrimary--primary.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--success {
  color: #ffffff;
  background-color: #04821f;
  border: 1px solid #04821f;
}
.vuiButtonPrimary--success.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--danger {
  color: #ffffff;
  background-color: #c41535;
  border: 1px solid #c41535;
}
.vuiButtonPrimary--danger.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--warning {
  color: #ffffff;
  background-color: #965a15;
  border: 1px solid #965a15;
}
.vuiButtonPrimary--warning.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--neutral {
  color: #2c313a;
  background-color: rgba(44, 49, 58, 0.1);
  border: 1px solid rgba(44, 49, 58, 0.1);
}
.vuiButtonPrimary--neutral.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--subdued {
  color: #69707d;
  background-color: rgba(105, 112, 125, 0.1);
  border: 1px solid rgba(105, 112, 125, 0.1);
}
.vuiButtonPrimary--subdued.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonSecondary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonSecondary--solid {
  background-color: #ffffff;
}

.vuiButtonSecondary--accent {
  border: 1px solid rgba(85, 30, 223, 0.5);
  color: #551edf;
}
.vuiButtonSecondary--accent.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--primary {
  border: 1px solid rgba(38, 76, 214, 0.5);
  color: #264cd6;
}
.vuiButtonSecondary--primary.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--success {
  border: 1px solid rgba(4, 130, 31, 0.5);
  color: #04821f;
}
.vuiButtonSecondary--success.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--danger {
  border: 1px solid rgba(196, 21, 53, 0.5);
  color: #c41535;
}
.vuiButtonSecondary--danger.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--warning {
  border: 1px solid rgba(150, 90, 21, 0.5);
  color: #965a15;
}
.vuiButtonSecondary--warning.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--neutral {
  border: 1px solid #cbcdde;
  color: #2c313a;
}
.vuiButtonSecondary--neutral.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--subdued {
  border: 1px solid #e3e4f3;
  color: #69707d;
}
.vuiButtonSecondary--subdued.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiFlexContainer {
  display: flex;
  align-items: stretch;
}

.vuiFlexContainer--fullWidth {
  width: 100%;
}

.vuiFlexContainer--wrap {
  flex-wrap: wrap;
}

.vuiFlexContainer--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexContainer--alignItemsCenter {
  align-items: center;
}

.vuiFlexContainer--alignItemsEnd {
  align-items: end;
}

.vuiFlexContainer--alignItemsStart {
  align-items: start;
}

.vuiFlexContainer--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexContainer--directionColumn {
  flex-direction: column;
}

.vuiFlexContainer--directionColumnReverse {
  flex-direction: column-reverse;
}

.vuiFlexContainer--directionRow {
  flex-direction: row;
}

.vuiFlexContainer--directionRowReverse {
  flex-direction: row-reverse;
}

.vuiFlexContainer--justifyContentCenter {
  justify-content: center;
}

.vuiFlexContainer--justifyContentEnd {
  justify-content: end;
}

.vuiFlexContainer--justifyContentStart {
  justify-content: start;
}

.vuiFlexContainer--justifyContentSpaceAround {
  justify-content: space-around;
}

.vuiFlexContainer--justifyContentSpaceBetween {
  justify-content: space-between;
}

.vuiFlexContainer--justifyContentSpaceEvenly {
  justify-content: space-evenly;
}

.vuiFlexContainer--spacingNone {
  gap: 0;
}

.vuiFlexContainer--spacingXxs {
  gap: 4px;
}

.vuiFlexContainer--spacingXs {
  gap: 8px;
}

.vuiFlexContainer--spacingS {
  gap: 12px;
}

.vuiFlexContainer--spacingM {
  gap: 16px;
}

.vuiFlexContainer--spacingL {
  gap: 24px;
}

.vuiFlexContainer--spacingXl {
  gap: 32px;
}

.vuiFlexContainer--spacingXxl {
  gap: 40px;
}

.vuiFlexItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vuiFlexItem--truncate {
  min-width: 40px;
}

.vuiFlexItem--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexItem--alignItemsCenter {
  align-items: center;
}

.vuiFlexItem--alignItemsEnd {
  align-items: end;
}

.vuiFlexItem--alignItemsStart {
  align-items: start;
}

.vuiFlexItem--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexItem--flexGrow0 {
  flex-grow: 0;
}

.vuiFlexItem--flexGrow1 {
  flex-grow: 1;
}

.vuiFlexItem--flexGrow2 {
  flex-grow: 2;
}

.vuiFlexItem--flexGrow3 {
  flex-grow: 3;
}

.vuiFlexItem--flexGrow4 {
  flex-grow: 4;
}

.vuiFlexItem--flexGrow5 {
  flex-grow: 5;
}

.vuiFlexItem--flexGrow6 {
  flex-grow: 6;
}

.vuiFlexItem--flexGrow7 {
  flex-grow: 7;
}

.vuiFlexItem--flexGrow8 {
  flex-grow: 8;
}

.vuiFlexItem--flexGrow9 {
  flex-grow: 9;
}

.vuiFlexItem--flexGrow10 {
  flex-grow: 10;
}

.vuiFlexItem--flexGrowNone {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiFlexItem--flexShrink0 {
  flex-shrink: 0;
}

.vuiFlexItem--flexShrink1 {
  flex-shrink: 1;
}

.vuiFlexItem--flexShrink2 {
  flex-shrink: 2;
}

.vuiFlexItem--flexShrink3 {
  flex-shrink: 3;
}

.vuiFlexItem--flexShrink4 {
  flex-shrink: 4;
}

.vuiFlexItem--flexShrink5 {
  flex-shrink: 5;
}

.vuiFlexItem--flexShrink6 {
  flex-shrink: 6;
}

.vuiFlexItem--flexShrink7 {
  flex-shrink: 7;
}

.vuiFlexItem--flexShrink8 {
  flex-shrink: 8;
}

.vuiFlexItem--flexShrink9 {
  flex-shrink: 9;
}

.vuiFlexItem--flexShrink10 {
  flex-shrink: 10;
}

.vuiFlexItem--flexShrinkNone {
  flex-basis: auto;
  flex-shrink: 0;
}

.vuiFlexItem--auto {
  flex-basis: auto;
}

.vuiFlexItem--content {
  flex-basis: content;
}

.vuiFlexItem--fill {
  flex-basis: fill;
}

.vuiFlexItem--maxContent {
  flex-basis: max-content;
}

.vuiFlexItem--minContent {
  flex-basis: min-content;
}

.vuiFlexItem--none {
  flex-basis: 0;
}

.vuiGridContainer {
  container-type: inline-size;
  width: 100%;
}

.vuiGrid {
  display: grid;
}

.vuiGrid--xss {
  column-gap: 4px;
  row-gap: 4px;
}

.vuiGrid--xs {
  column-gap: 8px;
  row-gap: 8px;
}

.vuiGrid--s {
  column-gap: 12px;
  row-gap: 12px;
}

.vuiGrid--m {
  column-gap: 16px;
  row-gap: 16px;
}

.vuiGrid--l {
  column-gap: 24px;
  row-gap: 24px;
}

.vuiGrid--xl {
  column-gap: 32px;
  row-gap: 32px;
}

.vuiGrid--xxl {
  column-gap: 40px;
  row-gap: 40px;
}

.vuiGrid--columns1 {
  grid-template-columns: 1fr;
}

.vuiGrid--columns2 {
  grid-template-columns: 1fr 1fr;
}

.vuiGrid--columns3 {
  grid-template-columns: 1fr 1fr 1fr;
}

@container (width < 800px) {
  .vuiGrid--columns3 {
    grid-template-columns: 1fr 1fr;
  }
}
@container (width < 500px) {
  .vuiGrid--columns2,
  .vuiGrid--columns3 {
    grid-template-columns: 1fr;
  }
}
.vuiLink {
  color: #264cd6 !important;
  text-decoration: none;
}
.vuiLink:hover {
  text-decoration: underline;
}
.vuiLink:hover * {
  text-decoration: underline;
}

.vuiLink--button {
  display: inline;
}

.vuiSearchInput {
  position: relative;
  display: flex;
  align-items: center;
}

.vuiSearchInput__input {
  flex-grow: 1;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  border-radius: 8px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  outline-width: 1px !important;
  outline-style: solid;
  outline-color: transparent;
  outline-offset: -1px !important;
}
.vuiSearchInput__input:focus-visible {
  outline-color: #264cd6 !important;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiSearchInput__submitButton {
  position: absolute;
  right: 12px;
  line-height: 0;
  color: #69707d;
  transition: all 0.2s;
}
.vuiSearchInput__submitButton:hover {
  color: #551edf;
}

.vuiSearchInput--m .vuiSearchInput__input {
  padding: 8px 16px;
  font-size: 14px;
}

.vuiSearchInput--l .vuiSearchInput__input {
  padding: 12px 16px;
  font-size: 18px;
}

.vuiSpinner {
  display: inline-block;
}

.vuiSpinner--accent svg path,
.vuiSpinner--accent svg rect {
  fill: #551edf;
}

.vuiSpinner--primary svg path,
.vuiSpinner--primary svg rect {
  fill: #264cd6;
}

.vuiSpinner--success svg path,
.vuiSpinner--success svg rect {
  fill: #04821f;
}

.vuiSpinner--danger svg path,
.vuiSpinner--danger svg rect {
  fill: #c41535;
}

.vuiSpinner--warning svg path,
.vuiSpinner--warning svg rect {
  fill: #965a15;
}

.vuiSpinner--empty svg path,
.vuiSpinner--empty svg rect {
  fill: #ffffff;
}

.vuiSpinner--dark svg path,
.vuiSpinner--dark svg rect {
  fill: #2c313a;
}

.vuiSpinner--xs {
  width: 14px;
  height: 14px;
}

.vuiSpinner--s {
  width: 15.9px;
  height: 15.9px;
}

.vuiSpinner--m {
  width: 20.08px;
  height: 20.08px;
}

.vuiSpinner--l {
  width: 48px;
  height: 48px;
}

.vuiSpinner--xl {
  width: 64px;
  height: 64px;
}

.vuiSpinner--xxl {
  width: 80px;
  height: 80px;
}

.vuiSpinner--xxxl {
  width: 100px;
  height: 100px;
}

.vuiSpacer {
  flex-shrink: 0;
}

.vuiSpacer--xxxs {
  height: 2px;
}

.vuiSpacer--xxs {
  height: 4px;
}

.vuiSpacer--xs {
  height: 8px;
}

.vuiSpacer--s {
  height: 12px;
}

.vuiSpacer--m {
  height: 16px;
}

.vuiSpacer--l {
  height: 24px;
}

.vuiSpacer--xl {
  height: 32px;
}

.vuiSpacer--xxl {
  height: 40px;
}

.vuiTopicButton {
  display: inline-block;
  text-decoration: none;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  transition: box-shadow 0.2s, border-color 0.2s;
  overflow: hidden;
  padding: 16px 24px;
  text-align: left;
}
.vuiTopicButton:hover {
  text-decoration: none;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px, #264cd6 0 0 1px 1px;
  z-index: 1;
}

.vuiTopicButton--fullWidth {
  width: 100%;
}

.vuiTitle {
  color: #2c313a;
  margin-bottom: 0;
}

.vuiTitle--xxs {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xs {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--s {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #69707d;
}

.vuiTitle--m {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--l {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xxl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--left {
  text-align: left;
}

.vuiTitle--center {
  text-align: center;
}

.vuiTitle--right {
  text-align: right;
}

.vuiText {
  overflow-wrap: break-word;
  word-break: break-word;
}
.vuiText ul {
  list-style: disc;
}
.vuiText ol {
  list-style: auto;
}
.vuiText ul,
.vuiText ol {
  margin-left: 16px;
  margin-bottom: 8px;
}
.vuiText ul:last-child,
.vuiText ol:last-child {
  margin-bottom: 0;
}
.vuiText a {
  color: #264cd6;
}

.vuiText--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiText--truncate * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vuiText--xs {
  color: #2c313a;
  font-size: 12px;
  line-height: 1.4;
}
.vuiText--xs p {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs p:last-child {
  margin-bottom: 0;
}

.vuiText--s {
  color: #2c313a;
  font-size: 14px;
  line-height: 1.4;
}
.vuiText--s p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s p:last-child {
  margin-bottom: 0;
}

.vuiText--m {
  color: #2c313a;
  font-size: 16px;
  line-height: 1.4;
}
.vuiText--m p {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m p:last-child {
  margin-bottom: 0;
}

.vuiText--l {
  color: #2c313a;
  font-size: 18px;
  line-height: 1.4;
}
.vuiText--l p {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l p:last-child {
  margin-bottom: 0;
}

.vuiText--left {
  text-align: left;
}

.vuiText--center {
  text-align: center;
}

.vuiText--right {
  text-align: right;
}

.vuiTextColor--accent {
  color: #551edf !important;
}

.vuiTextColor--primary {
  color: #264cd6 !important;
}

.vuiTextColor--success {
  color: #04821f !important;
}

.vuiTextColor--warning {
  color: #965a15 !important;
}

.vuiTextColor--danger {
  color: #c41535 !important;
}

.vuiTextColor--subdued {
  color: #69707d !important;
}

.vuiTextColor--neutral {
  color: #2c313a !important;
}`;import{jsx as je}from"react/jsx-runtime";var Xe=class extends HTMLElement{static get observedAttributes(){return["customerid","corpuskeys","apikey","title","placeholder","examplequestions","inputsize","isinitiallyopen","zindex","emptystatedisplayupdatetime","numberofsearchresults","language","enablefactualconsistencyscore","summarypromptname","rerankerId","lambda","enablestreaming","agenticconfigurationupdatetime","requestsource"]}constructor(){super(),this.sr=this.attachShadow({mode:"open"});try{this.sheet=new CSSStyleSheet,this.sheet.replaceSync(Qe),this.sr.adoptedStyleSheets=[this.sheet]}catch{let t=document.createElement("style");t.innerText=Qe,this.sr.appendChild(t)}this.mountPoint=document.createElement("div"),this.sr.appendChild(this.mountPoint)}setEmptyStateDisplay(t){this.emptyStateDisplay=t,this.setAttribute("emptystatedisplayupdatetime",Date.now().toString())}setAgenticConfiguration(t){this.agenticConfiguration=t,this.setAttribute("agenticconfigurationupdatetime",Date.now().toString())}connectedCallback(){var V,U,Q,X,R,L,Y,G,j,w,ee,$,F;let t=(V=this.getAttribute("customerId"))!=null?V:"",r=(U=this.getAttribute("corpuskeys"))!=null?U:"",n=(Q=this.getAttribute("apiKey"))!=null?Q:"",o=(X=this.getAttribute("title"))!=null?X:void 0,i=(R=this.getAttribute("placeholder"))!=null?R:void 0,s=this.getAttribute("exampleQuestions"),a=s?s.split(","):void 0,l=(L=this.getAttribute("inputSize"))!=null?L:void 0,p=this.getAttribute("isInitiallyOpen")==="true",B=(Y=this.emptyStateDisplay)!=null?Y:void 0,T=this.getAttribute("zIndex")!==null?parseInt(this.getAttribute("zIndex")):void 0,z=(G=parseInt(this.getAttribute("numberofsearchresults"),10))!=null?G:15,H=(j=this.getAttribute("language"))!=null?j:void 0,d=this.getAttribute("enableFactualConsistencyScore")==="true",N=(w=this.getAttribute("summaryPromptName"))!=null?w:void 0,E=(ee=this.getAttribute("customPrompt"))!=null?ee:void 0,S=this.getAttribute("rerankerId")!==null?parseInt(this.getAttribute("rerankerId"),10):void 0,O=this.getAttribute("lambda")!==null?parseFloat(this.getAttribute("lambda")):void 0,h=this.getAttribute("enableStreaming")!==null?this.getAttribute("enableStreaming")=="true":void 0,W=($=this.agenticConfiguration)!=null?$:void 0,v=(F=this.getAttribute("requestsource"))!=null?F:void 0;Lt.render(je("div",{children:je(Vt,{customerId:t,corpusKeys:r,apiKey:n,title:o,placeholder:i,exampleQuestions:a,inputSize:l,emptyStateDisplay:B,isInitiallyOpen:p,zIndex:T,enableStreaming:h,numberOfSearchResults:z,language:H,enableFactualConsistencyScore:d,summaryPromptName:N,customPrompt:E,rerankerId:S,lambda:O,agenticConfiguration:W,requestSource:v})}),this.mountPoint)}attributeChangedCallback(){this.connectedCallback()}};window.customElements.get("react-chatbot")||window.customElements.define("react-chatbot",Xe);var Ss=e=>{let t=Mr(null);Lr(()=>{t.current&&(e.emptyStateDisplay&&t.current.setEmptyStateDisplay(e.emptyStateDisplay),e.agenticConfiguration&&t.current.setAgenticConfiguration(e.agenticConfiguration))},[e]);let r=e,n=Object.keys(e).reduce((o,i)=>(i==="emptyStateDisplay"||(o[i]=r[i]),o),{});return je("react-chatbot",{ref:t,...n})};export{St as DEFAULT_LAMBDA_VALUE,Ct as DEFAULT_RERANKER_ID,yt as DEFAULT_SUMMARIZER,Ss as ReactChatbot};
